
import {map} from 'rxjs/operators';
/**
* Created by dinesh on 13/6/17.
*/
import { Component, AfterContentChecked, OnInit, OnDestroy  } from '@angular/core';
import { AngularTokenService } from '@lakshvairav/angular-token';
import { Router } from '@angular/router';
import { KeyValue } from '../key-value';
import { AuthorizationService } from '../authorization.service';
// import { FlashMessagesService } from 'angular2-flash-messages';

@Component({
  selector: 'app-shared-layout',
  templateUrl: 'layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements AfterContentChecked, OnInit, OnDestroy {
  user_email: string; sessions: any; selectedSessionId: any;
  enableLayoutMenu: boolean = false;
  all_teams:any=[];
  changePwdPath: string = KeyValue.changePasswordPath;
  changeControlPath: string = KeyValue.sessionControlPath;
  gettingStartedPath: string;
  demoLink: string;
  supportPath: string;
  homelink: string = '';
  enableLink: any;
  isNotStudent: boolean = false;
  isNotAdmin: boolean = false;
  enableLayoutPage: boolean = false;
  enableActionPage: boolean = false;
  role: string = ""
  subscription_getpresession:any;
  subscription_simulation1:any;
  subscription_rollback1:any
  current_team:any={}
  constructor(private router: Router, private _tokenService: AngularTokenService,
    private KeyValueService: KeyValue, public authService: AuthorizationService) {
    // this.user_email=this._tokenService.currentUserData.login
    this.role = this.authService.getCRole(); //this._tokenService.currentUserData.nickname;
    this.enableLink = this.authService.getCRole(); //this._tokenService.currentUserData.nickname;
    this.changePwdPath = this.authService.getChangePasswordPath();
    this.changeControlPath = this.authService.getChangeControlPath();
    this.enableLayoutMenu = this.authService.canEnableLayoutMenu();
    this.isNotStudent = this.authService.isNotStudent();
    this.isNotAdmin = this.authService.isNotAdmin();
    this.gettingStartedPath = KeyValue.gettingStartedPath;
    this.demoLink = KeyValue.demoLink;
    this.supportPath = KeyValue.supportPath;
    this.KeyValueService.simulation_status$.subscribe(
      data => {
        if (data == "show_simulation_link") {
          this.enableActionPage = true
        } else {
          this.enableActionPage = false
        }
      });
  }

  ngAfterContentChecked() {
    if (this._tokenService.userSignedIn()) {
      this.user_email = this.authService.getEmail(); //this._tokenService.currentUserData.uid;
    }
  }


  getDecisionStatus(){
    this.authService.get(KeyValue.decisionstatusPath).pipe(
      map(res => res)).subscribe(
      data => {
        console.log(data)
        this.KeyValueService.decision_sets_update(data)
      },
      error => {
        console.log('in... signin success' + error)
      }
    );
  }

  setTeam(event){
    this.authService.setTeam({id: event.target.value})
    let ctrl = this;
    setTimeout(function(){
      ctrl.getDecisionStatus()
    }, 1000);
    document.getElementById('decisions-set-popup').click();
  }

  HomePage(): any {
    this.homelink = this.authService.homePath();
    this.router.navigate([this.homelink]);
  }
  //filters the selected economy from sessions adn navigate to control page
  InsControl(session_id) {
    let selectedSession = this.sessions.filter(session => session.id == session_id);
    this.KeyValueService.setCurrentSession(selectedSession[0]);
    this.authService.setCurrentSession(selectedSession[0]);
    this.KeyValueService.current_session_update(selectedSession[0]);
    if (this.role === 'Instructor') {
    this.simulationStatusPath();
    }else {
      this.router.navigate([this.changeControlPath]);
    }
    let ctrl = this;
    let time_left = document.getElementById('time_left')
    var refreshIntervalId =  setInterval( () => {
      if (time_left != null) {
      time_left.innerText = "Loading..."
      }
    },1)
    setTimeout(function() {
      ctrl.getDecisions();
      ctrl.setWorkflowView();
      ctrl.rollBackSession();
      setTimeout(() => {
        if (time_left != null && time_left.innerText == "Loading..." ) {
          time_left.innerText = "Session Expired"
          clearInterval(refreshIntervalId);
        } else {
          clearInterval(refreshIntervalId);
        }
       }, 5000);
    }, 1000);

  }

  setWorkflowView() {
    console.log('layout component>setWorkflowView>api_getPresession')
    this.subscription_getpresession = this.authService.get(KeyValue.api_getPresession).pipe(
      map(res => res)).subscribe(
      data => {
        console.log("set workfllllllllllllllll")
        console.log(data)
        this.KeyValueService.workflow_update(data);
      }
      );
  }

  getDecisions() {
    this.authService.get(KeyValue.api_sessions_index).pipe(
    map(res => res)).subscribe(
    data => {
      const ele =  document.getElementById('execution-popup1');
      if (data.curent_session_executed === true && !ele.classList.contains('active')) {
        ele.classList.add('active');
        document.getElementById('execution_pop_up').style.display = 'block';

        ele.click();
      }
    }
  );
    this.authService.get(KeyValue.api_decisionsPath).pipe(
      map(res => res)).subscribe(
      data => {
        this.KeyValueService.current_decisions_update(data);
      }
      );
  }

  subscriptions() {
    //the subscribers will updated the selected session values when it is triggered.
    this.KeyValueService.current_session$.subscribe(
      data => {
        this.selectedSessionId = data.id;
      });

    // updates sessions when created
    this.KeyValueService.all_worksessions$.subscribe(
      data => {
        this.sessions.push(data);
      });

    // updates sessions when deleted from view summary
    this.KeyValueService.list_worksessions$.subscribe(
      data => {
        let index = this.sessions.map(function(o) { return o.id; }).indexOf(data.id)
        this.sessions.splice(index, 1);
      });

    // displays flash messages
    KeyValue.flash_msg.subscribe(
      data => {
        // document.getElementById('top_click').click()
        // window.scrollTo(10, 0);
        let flas_msg = document.getElementById('flash_message')
        flas_msg.style.display = 'block'
        flas_msg.classList.remove("success_messages")
        flas_msg.classList.remove("error_messages")
        flas_msg.classList.add(data.type)
        flas_msg.innerHTML = data.msg
        setTimeout(function() {
          flas_msg.style.display = 'none'
        }, 8000);
      }
    )
  }

  decision_timeout() {
    if (this.role != 'Student') {
      this.refreshContent();
    }
  }

  rollBackSession() {
    console.log('layout>rollBackSession>api_getPresession');
    this.subscription_rollback1 = this.authService.get(KeyValue.api_getPresession).pipe(
      map(res => res)).subscribe(
      data => {
        console.log(data)
        if (data.status == 200) {
          this.KeyValueService.current_rollback_decisions_update(data);
        }
      },
      error => {
        console.log(error);
      }
      );
  }

  refreshContent() {
    this.authService.get(KeyValue.api_decisionStatusUpdate).pipe(
      map(res => res)).subscribe(
      data => {
        this.KeyValueService.current_decisions_update(data);
        this.KeyValueService.simulation_status_data_update(data);
      }
      );
    // this.rollBackSession()
  }

  ngOnDestroy() {
    if (this.subscription_getpresession !== undefined) {
      this.subscription_getpresession.unsubscribe();
    }
    if (this.subscription_simulation1 !== undefined) {
      this.subscription_simulation1.unsubscribe();
    }
    if (this.subscription_rollback1 !== undefined) {
      this.subscription_rollback1.unsubscribe();
    }
  }
  ngOnInit() {
    this.authService.get(KeyValue.api_sessions_index).pipe(
      map(res => res)).subscribe(
      data => {
        this.sessions = data.worksessions;
        if (this.KeyValueService.getCurrentSession() == null) {
          this.KeyValueService.setCurrentSession(this.sessions[0]);
          this.authService.setCurrentSession(this.sessions[0]);
          this.KeyValueService.current_session_update(this.sessions[0]);
        }
        this.selectedSessionId = this.KeyValueService.getCurrentSession().id;
      },
      error => {
        console.log('in... signin success' + error)
      }
      );
    this.subscriptions();

    this.subscription_simulation1 = this.KeyValueService.simulation_status$.subscribe(
      data => {
        if (data === 'show_simulation_link') {
          this.enableLayoutPage = true
        } else {
          this.enableLayoutPage = false
        }
      });

      this.KeyValueService.decision_sets$.subscribe(
        data => {
          this.all_teams = data.teams;
          this.current_team = data.current_team;
        });


  }

  simulationStatusPath() {
    document.getElementById('decision_timeout').click();
    this.router.navigate([this.authService.getChangePath(KeyValue.simulationStatusPath)]);
  }

}
